// extracted by mini-css-extract-plugin
export default {"wrapper":"_WNGQ","infoBlocks":"Q2epD ZdH1P","products":"dO0vO"};